import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../../i18n/en';

i18next.addResourceBundle('en', 'dashboard', en);

const DashboardPermissionsUpdateConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Dashboard Permissions',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.HOME,
  permission: PERMISSION.UPDATE,
  routes: [
    {
      path: '/dashboard/permissions/:id',
      component: React.lazy(() => import('./DashboardPermissionsUpdate')),
    },
  ],
};

export default DashboardPermissionsUpdateConfig;
